/****************************************************************************
Match Height JS
****************************************************************************/

function matchHeights(selector) {
  const elements = document.querySelectorAll(selector);
  let maxHeight = 0;

  // Reset heights first
  elements.forEach(el => {
    el.style.height = 'auto';
  });

  // Get the max height
  elements.forEach(el => {
    const height = el.offsetHeight;
    if (height > maxHeight) maxHeight = height;
  });

  // Apply the max height
  elements.forEach(el => {
    el.style.height = maxHeight + 'px';
  });
}

const elementSelectors = [
  '.overview-blocks .block-description',
  '.overview-blocks .block-card-point',
  '.overview-blocks .block-heading',
  '.overview-blocks .block-subheading',
  '.image-card-carousel .card-slide'
];

function applyHeightMatching() {
  elementSelectors.forEach(selector => matchHeights(selector));
}

document.addEventListener("DOMContentLoaded", applyHeightMatching);
window.addEventListener("resize", applyHeightMatching);


// Home page image-card-carousel
document.addEventListener('DOMContentLoaded', function () {
  let swiperInstance = null;

  function initOrDestroySwiper() {
    const isMobile = window.innerWidth < 990;

    if (isMobile && !swiperInstance) {
      swiperInstance = new Swiper('.image-card-carousel', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        navigation: {
          nextEl: '.image-card-next',
          prevEl: '.image-card-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on: {
          init: () => applyHeightMatching(),
          resize: () => {
            setTimeout(() => applyHeightMatching(), 100);
          },
          slideChangeTransitionEnd: () => applyHeightMatching()
        }
      });

      applyHeightMatching(); // Initial call
    } else if (!isMobile && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  // Initialize on load
  initOrDestroySwiper();

  // Listen to window resize
  window.addEventListener('resize', () => {
    initOrDestroySwiper();
  });
});


// Home page Membership Benefits mobile slider
document.addEventListener('DOMContentLoaded', function () {
  let swiperInstance = null;

  function initOrDestroySwiper() {
    const isMobile = window.innerWidth < 990;

    if (isMobile && !swiperInstance) {
      swiperInstance = new Swiper('.overview-blocks-slider', {
        slidesPerView: 1,
        spaceBetween: 18,
        loop: false,
        navigation: {
          nextEl: '.overview-card-next',
          prevEl: '.overview-card-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on: {
          init: () => applyHeightMatching(),
          resize: () => {
            setTimeout(() => applyHeightMatching(), 100);
          },
          slideChangeTransitionEnd: () => applyHeightMatching()
        }
      });

      applyHeightMatching(); // Initial call
    } else if (!isMobile && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  // Initialize on load
  initOrDestroySwiper();

  // Listen to window resize
  window.addEventListener('resize', () => {
    initOrDestroySwiper();
  });
});


// Fallback for window resize
window.addEventListener("resize", () => {
  setTimeout(() => applyHeightMatching(), 100);
});

// Footer accordion
document.addEventListener('DOMContentLoaded', function () {
  const disclosureTitles = document.querySelectorAll('.footer__disclosures--title');

  disclosureTitles.forEach(title => {
    title.addEventListener('click', function () {
      // Close all other disclosure contents
      document.querySelectorAll('.footer__disclosures--content').forEach(content => {
        if (content !== this.nextElementSibling) {
          content.style.display = 'none';
          content.classList.remove('is-open');
        }
      });

      // Toggle the clicked one
      const content = this.nextElementSibling;
      if (content.classList.contains('is-open')) {
        content.style.display = 'none';
        content.classList.remove('is-open');
      } else {
        content.style.display = 'block';
        content.classList.add('is-open');
      }
    });
  });

  // Ensure all are closed by default
  document.querySelectorAll('.footer__disclosures--content').forEach(content => {
    content.style.display = 'none';
    content.classList.remove('is-open');
  });
});

// Cart checkout button disable

document.addEventListener("DOMContentLoaded", function() {
  // Select all agreement checkboxes and all checkout buttons
  const agreementCheckboxes = document.querySelectorAll(".cart__agreement .cart__agreement-checkbox");
  const checkoutButtons = document.querySelectorAll(".cart__checkout-button");
  const agreementFields = document.querySelectorAll(".cart__agreement-value");

  // Disable all checkout buttons by default
  checkoutButtons.forEach(button => button.disabled = true);

  function updateAllCheckboxes(isChecked) {
    // Update all checkboxes
    agreementCheckboxes.forEach(checkbox => checkbox.checked = isChecked);

    // Enable/disable all checkout buttons
    if(window.eligibleStates) {
      if(isChecked && window.checkZipCode) {
      checkoutButtons.forEach(button => button.disabled = false);
      } else {
        checkoutButtons.forEach(button => button.disabled = true);
      }
    } else {
      if(isChecked){
        checkoutButtons.forEach(button => button.disabled = false);
      } else {
        checkoutButtons.forEach(button => button.disabled = true);
      }
    }

    // Update value of all agreement fields
    agreementFields.forEach(field => field.value = isChecked ? "true" : "");
  }

  agreementCheckboxes.forEach(function(checkbox) {
    checkbox.addEventListener("change", function() {
      updateAllCheckboxes(this.checked);
    });
  });

  // --- BIRTH DATE LOGIC ---

  const birthDateInputs = document.querySelectorAll(".cart__birthdate");
  const birthDateFields = document.querySelectorAll(".cart__birthdate-value");

  function updateAllBirthdates(value) {
    birthDateInputs.forEach(input => input.value = value);
    birthDateFields.forEach(field => field.value = value);
  }

  birthDateInputs.forEach(function(input) {
    input.addEventListener("input", function() {
      updateAllBirthdates(this.value);
    });
  });
});


/*================= Browser Recognition Script =================*/

// Get user agent
const ua = navigator.userAgent.toLowerCase();

// Prepare classes
const body = document.body;

// Detect Safari (desktop or iOS) — NOT Chrome, NOT Edge
const isSafari = /^((?!chrome|android|crios|fxios|edgios).)*safari/i.test(navigator.userAgent);

// Detect Chrome
const isChrome = /chrome|crios/i.test(ua) && !/edg/i.test(ua);

// Detect Firefox
const isFirefox = /firefox|fxios/i.test(ua);

// Detect Edge
const isEdge = /edg/i.test(ua);

// Detect Opera
const isOpera = /opera|opr/i.test(ua);

// Add classes
if (isSafari) {
  body.classList.add("browser-safari");
} else if (isChrome) {
  body.classList.add("browser-chrome");
} else if (isFirefox) {
  body.classList.add("browser-firefox");
} else if (isEdge) {
  body.classList.add("browser-edge");
} else if (isOpera) {
  body.classList.add("browser-opera");
} else {
  body.classList.add("browser-other");
}
